/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetMeResponseData,
  GetMeResponseDataFromJSON,
  GetMeResponseDataFromJSONTyped,
  GetMeResponseDataToJSON
} from './GetMeResponseData'

/**
 *
 * @export
 * @interface RestoreOrganizationUserResponse
 */
export interface RestoreOrganizationUserResponse {
  /**
   *
   * @type {number}
   * @memberof RestoreOrganizationUserResponse
   */
  status?: number
  /**
   *
   * @type {GetMeResponseData}
   * @memberof RestoreOrganizationUserResponse
   */
  data?: GetMeResponseData
}

export function RestoreOrganizationUserResponseFromJSON(json: any): RestoreOrganizationUserResponse {
  return RestoreOrganizationUserResponseFromJSONTyped(json, false)
}

export function RestoreOrganizationUserResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RestoreOrganizationUserResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetMeResponseDataFromJSON(json['data'])
  }
}

export function RestoreOrganizationUserResponseToJSON(value?: RestoreOrganizationUserResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetMeResponseDataToJSON(value.data)
  }
}
